import {Map, fromJS} from "immutable";

export const hasStateProvince = (countryCode) => {
  if (countryCode === "US") return true;
  if (countryCode === "CA") return true;
  if (countryCode === "ES") return true;
  return false;
}

export const hasStateProvinceForAddress = (address) => {
  return hasStateProvince(address.get("addressCountryCode", ""))
}

export const applyStateProvinceRule = (address) => {
  if (Map.isMap(address)) {
    if (hasStateProvinceForAddress(address)) return address;
    return address.set("addressStateProvince", "");
  } else {
    let theAddress = fromJS(address);
    if (hasStateProvinceForAddress(theAddress)) return address;
    return theAddress.set("addressStateProvince", "").toJS();
  }
}